import { useMutation } from "@apollo/client/react";

import { DELETE_MANAGED_USER } from "../../../gql";

const useDeleteUser = () => {
  const [deleteManagedUser, { loading }] = useMutation(DELETE_MANAGED_USER, {
    refetchQueries: ["GetManagedUsers", "GetAccountSettings"],
  });

  const onDelete = (id: string) => {
    return deleteManagedUser({
      variables: {
        id,
      },
    });
  };

  return { onDelete, loading };
};

export default useDeleteUser;
